// src/components/about/AboutHeader.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';

// Move image URLs here or import them properly
const imperial = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Flogos%2Fimperial-college-london-logo.png?alt=media&token=a2e5bf66-50d7-4be9-ade4-8c53538439d4";
const mrcLogo = "https://firebasestorage.googleapis.com/v0/b/plasticanalytics-ada31.appspot.com/o/landingPage%2Flogos%2Fmrc-centre-logo.png?alt=media&token=5b047c0f-3a34-4add-9547-fecad60e109f";

const AboutHeader = () => {
  return (
    <AnimateOnScroll>
      <div style={{
        borderBottom: '1px solid #e5e5e5',
        padding: '20px 0',
        marginBottom: '40px',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap', // Allow wrapping on smaller screens
          gap: '20px' // Add gap for wrapped items
        }}>
          <div>
            <h1 style={{
              fontSize: '2.5rem',
              fontWeight: 'normal',
              margin: 0,
              fontFamily: 'Helvetica',
            }}>
              About
            </h1>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: 'normal',
              color: '#6b7280',
              margin: '5px 0 0 0',
              fontFamily: 'Helvetica',
            }}>
              PlasticAnalytics
            </h2>
          </div>

          <div style={{
            display: 'flex',
            gap: '20px',
            alignItems: 'center'
          }}>
            <a href="https://www.imperial.ac.uk/" target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
              <img src={imperial} alt="Imperial College London" style={{ height: '30px', width: 'auto' }} />
            </a>
            <a href="http://www.environment-health.ac.uk/" target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
              <img src={mrcLogo} alt="MRC Centre Logo" style={{ height: '40px', width: 'auto' }} />
            </a>
          </div>
        </div>
      </div>
    </AnimateOnScroll>
  );
};

export default AboutHeader;